import React, { Component } from "react";
import Login from "./Login";
import Registration from "./Registration";
import OTP from "./otp";
import axios from "axios";
import { getParameterAPI } from "../PolicyDetail/PolicyDetailService/policyDetailService";
import Maintanance from "./Maintanance";


export class Main extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 1,
      username: "",
      password: "",
      confirm_password: "",
      otp: "",
      variable2: "",
      variable3: "",
      listService: [],
      maintenanceClose: "Y"

    };
  }
  // state =
  // Proceed to next step
  nextStep = () => {
    const { step } = this.state;
    this.setState({
      step: step + 1,
    });
  };

  // Go back to login_page
  login_page = () => {
    const { step } = this.state;
    this.setState({
      step: 3,
    });
  };
  // Go back to prev step
  prevStep = () => {
    const { step } = this.state;
    this.setState({
      step: step - 1,
    });
  };

  // Handle fields change
  handleChange = (input) => (e) => {
    this.setState({ [input]: e.target.value });
  };

  componentDidMount() {
    this.checkMaintenance();
  }

  async checkMaintenance() {
    try {
      const response = await getParameterAPI(25);
      if (response.payload) {
        if (response.payload.length > 0) {
          const data = response.payload[0];
          if (data.variable1 == "Y") {
            let listservice = [];
            if (data.variable4) {
              listservice.push(data.variable4);
            }
            if (data.variable5) {
              listservice.push(data.variable5);
            }
            if (data.variable6) {
              listservice.push(data.variable6);
            }
            if (data.variable7) {
              listservice.push(data.variable7);
            }
            if (data.variable8) {
              listservice.push(data.variable8);
            }
            if (data.variable9) {
              listservice.push(data.variable9);
            }
            this.setState({
              step: null,
              variable2: data.variable2,
              variable3: data.variable3,
              listService: listservice,
            });
          }
        }
      }
      console.log("response", response);
    } catch (error) {
      console.error("API call failed", error);
    }
  }

  render() {
    const { variable2, variable3 ,listService} = this.state;
    const { step } = this.state;
    const { username, password, otp, confirm_password } = this.state;
    const values = { username, password, confirm_password, otp };
    // alert(step)
    switch (step) {
      case 1:
        return (
          <Login
            nextStep={this.nextStep}
            handleChange={this.handleChange}
            prevStep={this.prevStep}
          />
        );
      case 2:
        return (
          <Registration
            nextStep={this.nextStep}
            handleChange={this.handleChange}
            values={values}
            prevStep={this.prevStep}
          />
        );
      case 3:
        return (
          <OTP
            nextStep={this.nextStep}
            handleChange={this.handleChange}
            login_page={this.login_page}
            values={values}
          />
        );
        default:
          return <Maintanance start={variable2} end={variable3} listServer={listService} />;
         
    }
  }
}

export default Main;
